import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import styles from "./components.module.scss";
import WarningTick from "../../Assets/warning_tick.svg";
import ErrorTick from "../../Assets/error_tick.svg";

const dialogTitleStyles = (theme) => ({
    root: {
        margin: 0,
        padding: 0,
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(dialogTitleStyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        justifyContent: "center",
    },
}))(MuiDialogActions);

export default function ResponseModal(props) {
    const { open, onClose, type = "", title, message, buttonText = "Done" } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="response-modal-title"
            classes={{ paper: styles.responseModalPaper }}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="response-modal-title" onClose={onClose} />
            <DialogContent>
                <img
                    src={type === "error" ? ErrorTick : WarningTick}
                    alt={type === "error" ? "error" : "warning"}
                    className={styles.responseIcon}
                />
                <Typography variant="h5" className={styles.responseHeading}>
                    {title || (type === "error" ? "Error" : "Warning")}
                </Typography>
                {message && (
                    <Typography
                        variant="body1"
                        className={styles.responseContent}
                    >
                        {message}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="contained"
                    className={styles.responseButton}
                >
                    {buttonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
